<template>
  <div v-loading='loadingUserScope'>
    <!-- <el-button type='primary' :disabled='false'>Επιστροφή</el-button> -->
    <register-form v-if='modifyUser' v-loading="loadingUser"
      :addUser='addUser' :modifyUser='modifyUser' :modifyRole='modifyRole'
      :modifyFromUser='modifyFromUser' :userData='currentUser' :roleId='roleId' :academicAreas='academicAreas'>
    </register-form>
  </div>
</template>

<script>
import RegisterForm from './common/RegisterForm'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    RegisterForm
  },
  mounted: function () {
  },
  data () {
    return {
      modifyFromUser: true,
      addUser: false,
      modifyUser: true,
      modifyRole: false,
      loadingUser: false,
      modifyUserData: {doatap_roles: []},
      roleId: 0
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'loadingUserScope']),
    ...mapState(['academicAreas'])
  },
  methods: {
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue